import { request } from "../_helpers/Auth";

const namespace = "/api";

export const getInterventions = () => {
    return request({
        url: namespace + "/interventions",
        method: "get",
    });
};

export const getIntervention = (task_id) => {
    return request({
        url: namespace + "/intervention/" + task_id,
        method: "get",
    });
};

export const createIntervention = (payload) => {
    return request({
        url: namespace + "/intervention",
        data: payload,
        method: "post",
    });
};

export const updateIntervention = (payload) => {
    return request({
        url: namespace + "/intervention",
        data: payload,
        method: "put",
    });
};

export const destroyIntervention = (task_id) => {
    return request({
        url: namespace + "/intervention/" + task_id,
        method: "delete",
    });
};

export const downloadInterventions = (payload) => {
    return request({
        url: namespace + "/interventions/download",
        data: payload,
        method: "post",
        responseType: "blob",
    });
};